import React from 'react';
import './styles.css';





export const VictoriaAyudanteDerecha = () => {


  return (
    <>


        <div className='VictoriaAyudanteDerecha-Container'>

              <div className='VictoriaAyudanteDerecha-nombre-texto-container'>
                  
                    <div className='VictoriaAyudanteDerecha-nombre' />

                    <div className='VictoriaAyudanteDerecha-texto'>

                          <div className='VictoriaAyudanteDerecha-texto-subcontainer'>

                              Educadora Infantil. Tutora del aula de 0-1 años.
                              
                          </div>
                          
                    </div> 

              </div>

              <div className='VictoriaAyudanteDerecha-maestra' />
            
        </div>


    </>
  )
}
